module.exports = __webpack_public_path__ + "img/1023.61a28fd1.png";